import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { waterburyConfig } from "./data";

export default function WaterburyPage() {
  return <CityPageTemplate config={waterburyConfig} />;
}